import { computed, ref, watch } from '@vue/composition-api';
import useAccountTransaction from '@/modules/account/composables/useAccountTransaction';
import useUtils from '@/composables/useUtils';

const useAccountTransactionsList = () => {
  const { fetchTransactions } = useAccountTransaction();
  const { formatDateYyyyMmDd, convertDateToUTC } = useUtils();

  const perPageOptions = [10, 25, 50, 100];
  const tableColumns = [
    { key: 'id', label: '#', sortable: true },
    { key: 'transactionStatusId', label: 'Status' },
    { key: 'accountId', label: 'Account', sortable: true },
    { key: 'taxiId', label: 'Taxi', sortable: true },
    { key: 'bookingId', label: 'Booking', sortable: true },
    { key: 'postId', label: 'Post', sortable: true },
    { key: 'tourId', label: 'Tour', sortable: true },
    { key: 'amount', sortable: true },
    { key: 'transactionDateUtc', label: 'Date', sortable: true },
    { key: 'actions' },
  ];

  const pageNumber = ref(1);
  const orderDesc = ref(true);
  const pageSize = ref(10);
  const refTransactionList = ref(null);
  const orderBy = ref('id');
  const totalTansactions = ref(0);

  const account = ref(
    localStorage.getItem('accountTransactionList-account') == 'null'
      ? null
      : JSON.parse(localStorage.getItem('accountTransactionList-account')));
  const transactionStatus = ref(
    localStorage.getItem('accountTransactionList-transactionStatus') == 'null'
      ? null
      : JSON.parse(localStorage.getItem('accountTransactionList-transactionStatus')));
  const searchQuery = ref(
    localStorage.getItem('accountTransactionList-searchQuery') == ''
      ? ''
      : localStorage.getItem('accountTransactionList-searchQuery')
  );
  const searchByDate = ref(
    localStorage.getItem('accountTransactionList-searchByDate') == ''
      ? ''
      : localStorage.getItem('accountTransactionList-searchByDate')
  );

  const dataMeta = computed(() => {
    const localItemsCount = refTransactionList.value
      ? refTransactionList.value.localItems.length
      : 0;
    return {
      from: pageSize.value * (pageNumber.value - 1) + (localItemsCount ? 1 : 0),
      to: pageSize.value * (pageNumber.value - 1) + localItemsCount,
      of: totalTansactions.value,
    };
  });

  watch(
    [pageNumber, pageSize, account, transactionStatus, searchByDate],
    () => {
      localStorage.setItem(
        'accountTransactionList-account',
        JSON.stringify(account.value)
      );
      localStorage.setItem(
        'accountTransactionList-transactionStatus',
        JSON.stringify(transactionStatus.value)
      );
      
      localStorage.setItem(
        'accountTransactionList-searchByDate',
        searchByDate.value
      );
      refTransactionList.value.refresh();
    }
  );

  const refreshTable = () => {
    localStorage.setItem(
        'accountTransactionList-searchQuery',
        searchQuery.value
      );
    refTransactionList.value.refresh();
  }

  const clearSearchByDate = () => {
    searchByDate.value = '';
    localStorage.setItem(
        'accountTransactionList-searchByDate',
        searchByDate.value)
  };

  const getTransactionList = (_, callback) => {
    const params = {
      orderBy: orderBy.value,
      orderDesc: orderDesc.value,
      searchByDate: searchByDate.value === '' ? null : formatDateYyyyMmDd(convertDateToUTC(searchByDate.value)),
      pageSize: pageSize.value,
      pageNumber: pageNumber.value,
      accountId: account.value?.id ?? undefined,
      transactionStatusId: transactionStatus.value?.id ?? undefined,
      searchQuery: searchQuery.value,
    };

    fetchTransactions(params).then(({ transactions, total }) => {
      callback(transactions);
      totalTansactions.value = total;
    });
  };

  return {
    // Const
    perPageOptions,
    tableColumns,

    // Reactive
    orderBy,
    orderDesc,
    pageNumber,
    pageSize,
    refTransactionList,
    searchQuery,
    account,
    transactionStatus,
    totalTansactions,
    searchByDate,

    // Computed
    dataMeta,

    // Method
    getTransactionList,
    clearSearchByDate,
    refreshTable,
  };
};

export default useAccountTransactionsList;
